import React from 'react';

const CareersHero: React.FC = () => {
  return (
    <section 
      className="relative py-20 bg-gradient-to-br from-blue-50 to-indigo-100 overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20biotechnology%20laboratory%20with%20scientists%20working%20on%20genomics%20research%2C%20clean%20white%20environment%20with%20advanced%20equipment%2C%20professional%20team%20collaboration%2C%20bright%20lighting%2C%20scientific%20innovation%20atmosphere%2C%20high-tech%20bioinformatics%20workspace&width=1920&height=600&seq=careers-hero&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-white/80"></div>
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          加入我们的团队
        </h1>
        <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
          我们正在寻找优秀的生物信息学人才加入我们的专业团队，共同推动生命科学研究的前沿发展
        </p>
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
          <div className="flex items-center">
            <i className="ri-time-line text-blue-600 mr-2"></i>
            <span>时间灵活</span>
          </div>
          <div className="flex items-center">
            <i className="ri-global-line text-blue-600 mr-2"></i>
            <span>远程协作</span>
          </div>
          <div className="flex items-center">
            <i className="ri-money-dollar-circle-line text-blue-600 mr-2"></i>
            <span>报酬丰厚</span>
          </div>
          <div className="flex items-center">
            <i className="ri-briefcase-line text-blue-600 mr-2"></i>
            <span>项目结算</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersHero;